import { useStudentStore } from "../../hooks/use-student-store";

const IntroductionCard = () => {
  const { preLesson } = useStudentStore();

  if (!preLesson?.introduction) return null;

  return (
    <div>
      <h2 className="text-base font-semibold text-gray-900 mb-2">Introduction</h2>
      <p className="text-sm text-gray-900 leading-relaxed">
        {preLesson.introduction}
      </p>
    </div>
  );
};

export default IntroductionCard;
